import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from 'ngx-flexible-layout';
// import { SharedModule } from "../../Core/shared.module";
import { MatButtonModule } from '@angular/material/button';
// import { MessageBoxComponent } from "./MessageBox/messageBox.component";
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  DxListModule,
  DxLoadIndicatorModule,
  DxPopupModule,
  DxScrollViewModule,
  DxTemplateModule,
} from 'devextreme-angular';
import { LoadProtocolComponent } from './load-protocol/load-protocol.component';
import { LoadProtocolService } from './load-protocol/load-protocol.service';
import { MessageBoxComponent } from './messageBox/messageBox.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [MessageBoxComponent, LoadProtocolComponent],
  exports: [MessageBoxComponent, LoadProtocolComponent, MatIconModule],
  imports: [
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    // SharedModule,
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    FormsModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MatDividerModule,
    MatExpansionModule,
    DxListModule,
    DxPopupModule,
    DxTemplateModule,
    MatListModule,
    DxLoadIndicatorModule,
    DxScrollViewModule,
    ClipboardModule,
  ],
  providers: [LoadProtocolService, provideHttpClient(withInterceptorsFromDi())],
})
export class AbcMessagesModule {}
